import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const AutocompleteDark = ({
  options,
  getOptionLabel,
  value,
  onChange,
  label = "Select Option",
  ...props
}) => (
  <Autocomplete
    options={options}
    getOptionLabel={getOptionLabel}
    value={value}
    onChange={onChange}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        variant="outlined"
        sx={{
          "& .MuiInputBase-root": { color: "#ddd9d5", backgroundColor: "#252525" },
          "& .MuiInputLabel-root": {
            color: "#ddd9d5",
            "&.Mui-focused": {
              color: "#ddd9d5",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ddd9d5" },
          "& .MuiOutlinedInput-input": { color: "#ddd9d5" },
          "& .MuiIconButton-root": { color: "#ddd9d5" },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ddd9d5",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ddd9d5",
          },
        }}
      />
    )}
    slotProps={{
      popper: {
        sx: {
          backgroundColor: "#252525 !important",
          "& .MuiAutocomplete-paper": {
            backgroundColor: "#252525",
            color: "#ddd9d5",
          },
          "& .MuiAutocomplete-listbox": {
            "& .MuiAutocomplete-option": {
              backgroundColor: "#252525",
              color: "#ddd9d5",
              "&[aria-selected='true']": {
                backgroundColor: "#444444",
                color: "#ffffff",
              },
              "&:hover": {
                backgroundColor: "#333333",
              },
            },
          },
        },
      },
    }}
    {...props} // Pass any additional props to Autocomplete
  />
);

export default AutocompleteDark;
